import { Outlet } from "react-router-dom"
import AreaSwitcherComponent from "../../components/templates/components/AreaSwitcherComponent"
import BackButton from "../../components/templates/components/backButton"
import { t } from "i18next";

const EvdaPage = () => {
  return(<>
    <div className="back-container">
      <BackButton></BackButton>
    </div>

    <nav role="navigation" aria-label={ t("aria-label--evda-menu") || undefined }>
      <div role="tablist" className="switcher-container">
        <ul><AreaSwitcherComponent></AreaSwitcherComponent></ul>
      </div>
    </nav>

    <Outlet />
  </>);
}

export default EvdaPage